var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgm-controller",attrs:{"id":"BgmController"}},[_c('v-btn',{attrs:{"icon":"","small":_vm.isSmp},on:{"click":_vm.onToggleBgm}},[_c('v-icon',[_vm._v(_vm._s(_vm.isBgmMuted ? 'mdi-volume-off' : 'mdi-volume-high'))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }